import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesBanners } from "../../constants";
import { UpdateBannerBody, UpdateBannerResponse } from "./updateBanner.types";

export const requestUpdateBanner = async ({
  id,
  body
}: UpdateBannerBody): Promise<UpdateBannerResponse> => {
  return await instance.patch(buildUrl(ApiRoutesBanners.Banners, id), body);
};
